<template>
	<div ref="scrollContainer" class="whole-div-PFG">
		<!--    第一行-->
		<div class="div1-PFG">
			<swiper ref="mySwiper" :options="swiperOptions" style="width: 100%;height: 100%">
				<swiper-slide v-for="(item,index) in swiperList" :key="index" style="width: 100%;height: 100%">
					<img :src="item.src" :title="item.title" alt="畜禽无害化智能处理机" width="100%" height="100%">
				</swiper-slide>
<!--				<div class="swiper-pagination" slot="pagination"></div>-->
<!--				<div class="swiper-button-prev" slot="button-prev"></div>-->
<!--				<div class="swiper-button-next" slot="button-next"></div>-->
			</swiper>
		</div>
		<!--    第二行:关于我们-->
		<div class="div2-PFG">
			<a class="div2-a-PFG">
				<a class="div2-a-a-PFG"><i>About us / </i><strong> 关于我们</strong></a>
				<br><br>
				致力于畜禽无害化处理智能设备与废气、废水处理设备的研发与生产
			</a>
		</div>
		<!--    第三行：关于我们的内容-->
		<div class="div3-PFG">
			<!--      公司图片+公司介绍-->
			<div class="div3-div1-PFG">
				<div class="div3-div1-div1-PFG">
					<img :src="companyImg" alt="" width="100%" height="100%">
				</div>
				<div class="div3-div1-div2-PFG">
					<a class="div3-a1-PFG"><strong>浙江纵海自动化设备有限公司</strong></a>
					<a class="div3-a2-PFG">
						&#12288;&#12288;浙江纵海自动化设备有限公司，是一家从事畜禽无害化处理设备与废气、废水处理设备设计、开发、制造、销售、服务为一体的专业化公司。
						公司始建于二零壹六年，注册资金1050万元。现拥有5000余平方米标准生产厂区以及数家无害化处理公司。
						配备完善的基地设施与设备。公司现有技术研发人员以及高级技工30余人，涵盖设计、安装、调试、机械、电器、计算机、培训等领域。
					</a>
          <div style="width: 100%;position: absolute;bottom: 10px">
            <el-button type="info" @click="routing('产品中心')">了解更多</el-button>
            <el-button style="margin-left:5%" type="primary" @click="routing('联系我们')">联系我们</el-button>
          </div>
				</div>
			</div>
		</div>
		<div style="width: 100%;height: 30px;background-color: whitesmoke"></div>
		<!--    第四行：各种图标-->
		<div class="div4-PFG">
			<div class="div4-div1-PFG" @click="routing('公司介绍')">
				<a><img :src="companyIntroduceImg" alt="" width="150px" height="150px" style="cursor: pointer;"></a>
				<br>
				<a style="cursor: pointer;">公司介绍</a>
			</div>
      <div class="div4-div2-PFG" @click="routing('荣誉资质')">
        <a><img :src="honorImg" alt="" width="150px" height="150px" style="cursor: pointer;"></a>
        <br>
        <a style="cursor: pointer;">荣誉资质</a>
      </div>
			<div class="div4-div2-PFG" @click="routing('联系我们')">
				<a><img :src="contactUsImg" alt="" width="150px" height="150px" style="cursor: pointer;"></a>
				<br>
				<a style="cursor: pointer;">联系我们</a>
			</div>
		</div>
		<div style="width: 100%;height: 30px;background-color: whitesmoke"></div>
		<!--    第五行：产品中心-->
		<div class="div5-PFG">
			<a class="div5-a-PFG">
				<a class="div5-a-a-PFG"><i>Our Product / </i><strong> 我们的业务</strong></a>
				<br><br>
				致力于畜禽无害化处理智能设备与废气、废水处理设备的研发与生产
			</a>
		</div>
		<!--    第6行：产品中心内容-->
		<div class="div6-PFG">
			<div class="div6-div1-PFG">
				<div class="div6-div1-div1-PFG">
					<a class="div6-a1-PFG"><strong>畜禽无害化智能处理机</strong></a>
					<a class="div6-a2-PFG">
						&#12288;&#12288;畜禽无害化智能处理机,对病死畜禽及其制品主要采取干化法分类进行无害化处理，通过
						通过高温裂解，将病原体完全杀灭，并使油脂融化和蛋白质凝固，经化制后的油脂可用于工业用油；
						肉骨粉可用于有机肥料加工的原材料。
					</a>
					<div style="width: 100%;position: absolute;bottom: 10px">
						<el-button type="info" @click="routing('产品中心')">了解更多</el-button>
						<el-button style="margin-left:5%" type="primary" @click="routing('联系我们')">联系我们</el-button>
					</div>
				</div>
				<div class="div6-div1-div2-PFG">
					<img :src="productImg" alt="" width="100%" height="100%">
				</div>
			</div>
		</div>
		<div style="width: 100%;height: 30px"></div>
		<!--第7行：新闻中心-->
		<div class="div7-PFG">
			<a class="div7-a-PFG">
				<a class="div7-a-a-PFG"><i>News Center / </i><strong> 新闻中心</strong></a>
				<br><br>
				致力于畜禽无害化处理智能设备与废气、废水处理设备的研发与生产
			</a>
		</div>
		<!-- 第8行：新闻中心内容 -->
		<div class="div8-PFG">
			<div class="div8-div-PFG">
				<div style="position:absolute; right: 4%;"><button @click="routing('新闻中心')" style="height: 30px;cursor: pointer;">点击加载更多...</button></div>
				<div class="div8-divLeft1-PFG" @click="clickQuestionIntroduce(newsList1)">
					<br>
					<a class="div8-a1-PFG"><strong>{{newsList1.title}}</strong></a>
					<br><br>
					<a class="div8-a2-PFG">发布日期：{{newsList1.dateTime}}</a>
					<br><br>
					<a class="div8-a3-PFG">&#12288;&#12288;{{newsList1.details}}</a>
					<br><br>
					<a class="div8-a4-PFG"><el-button @click="clickQuestionIntroduce(newsList1)" type="primary">了解详情</el-button></a>
				</div>
				<div class="div8-divRight1-PFG" @click="clickQuestionIntroduce(newsList2)">
          <br>
          <a class="div8-a1-PFG"><strong>{{newsList2.title}}</strong></a>
          <br><br>
          <a class="div8-a2-PFG">发布日期：{{newsList2.dateTime}}</a>
          <br><br>
          <a class="div8-a3-PFG">&#12288;&#12288;{{newsList2.details}}</a>
          <br><br>
          <a class="div8-a4-PFG"><el-button @click="clickQuestionIntroduce(newsList2)" type="primary">了解详情</el-button></a>
				</div>
				<div class="div8-divLeft2-PFG" @click="clickQuestionIntroduce(newsList3)">
          <br>
          <a class="div8-a1-PFG"><strong>{{newsList3.title}}</strong></a>
          <br><br>
          <a class="div8-a2-PFG">发布日期：{{newsList3.dateTime}}</a>
          <br><br>
          <a class="div8-a3-PFG">&#12288;&#12288;{{newsList3.details}}</a>
          <br><br>
          <a class="div8-a4-PFG"><el-button @click="clickQuestionIntroduce(newsList3)" type="primary">了解详情</el-button></a>
				</div>
				<div class="div8-divRight2-PFG" @click="clickQuestionIntroduce(newsList4)">
          <br>
          <a class="div8-a1-PFG"><strong>{{newsList4.title}}</strong></a>
          <br><br>
          <a class="div8-a2-PFG">发布日期：{{newsList4.dateTime}}</a>
          <br><br>
          <a class="div8-a3-PFG">&#12288;&#12288;{{newsList4.details}}</a>
          <br><br>
          <a class="div8-a4-PFG"><el-button @click="clickQuestionIntroduce(newsList4)" type="primary">了解详情</el-button></a>
				</div>
			</div>
		</div>
		<!-- 第9行：底框 -->
		<div class="div9-PFG">
      <div style="width: 25%;height: 100%"></div>
			<div class="div9-div1-PFG">
        <img src="../../public/image/浙江纵海.jpg" alt="" height="80%">
      </div>
      <div class="div9-div2-PFG">
        <div style="width: 60%;position: relative;text-align: left">
          <a style="font-size: 20px;font-weight: bold;">联系方式</a><br><br>
          <a >联系人：{{this.$store.state.contactIntroduce.personName}}</a><br>
          <a >手机号码：{{this.$store.state.contactIntroduce.phoneNumber}}</a><br>
          <a>电话号码：{{this.$store.state.contactIntroduce.telephoneNumber}}</a><br>
          <a>地址：{{this.$store.state.contactIntroduce.address}}</a><br>
          <a>邮箱：{{this.$store.state.contactIntroduce.email}}</a>
        </div>
      </div>
      <div class="div9-div3-PFG">
        <div style="text-align: left">
          <a style="font-family: Avenir">Copyright © 2024</a><br><br>
          <a>版权所有©浙江纵海自动化设备有限公司</a><br>
          <a class="div9-div3-a1-PFG" href="https://beian.miit.gov.cn/" target="_blank">{{this.$store.state.contactIntroduce.recordNumber}}</a><br>
          <a class="div9-div3-a1-PFG" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33108202000840" target="_blank">{{this.$store.state.contactIntroduce.policeRecordNumber}}</a><br><br>
          <a>声明:本站部分数据来源于互联网,与本公司无关,若有侵权请联系客服删除。</a>
        </div>
      </div>
		</div>
	</div>
</template>

<script>
	import '../css/pc/PFG_PcFirstPage.css';
	import {
		Swiper,
		SwiperSlide
	} from 'vue-awesome-swiper';
	import 'swiper/css/swiper.css';

	export default {
		name: "PcFirstPage",
		data() {
			return {
				//标题，日期，内容
				newsList1:{
					title:'强化病死动物无害化处理监管',
					dateTime:'2024-5-17',
					details:'2月19日我部和国务院食品安全办、食品药品监管总局联合引发了《国务院食品安全办、农业部、国家食品药品监督管理总局关于进一步加强病死动物及其产品监管工作的通知》（食安办[2014]5号）（以下简称“通知”）。各地要认真贯彻落实“通知”精神，切实强化病死动物无害化处理监管工作。要采取有效措施督促落实动物养殖、屠宰等生产经营者主体责任。推动辖区内病死动物无害化处理场所所统筹规划、设施设备建设完善工作。上海、浙江、江苏、安徽、江西等水网密集省份要立即开展拉网式排查，坚决杜绝“黄浦江漂浮死猪”类似事件再次发生，要积极配合有关部门，强化执法检查，加强联防联控，严防病死动物产品流入市场和餐桌。',
				},
        newsList2:{
          title:'如何判断哪些畜禽和畜禽产品应当进行无害化处理',
          dateTime:'2024-5-17',
          details:'1.染疫或者疑似疫死亡、因病死亡或者死因不明的；\n2.经检疫、检验可能危害人体或者动物健康的；因自然灾害、应激反应、物理挤压等因素死亡的；\n3.屠宰过程中经肉品品质检验确认为不可食用的；死胎、木乃伊胎等；\n4.因动物疫病防控需要被扑杀或销毁的；其他应当进行无害化处理的。',
        },
        newsList3:{
          title:'畜禽无害化智能处理机相比较传统处理方法的好处',
          dateTime:'2024-5-17',
          details:'1.此设备采用高温高压处理，能更彻底的杀死杀灭病菌。\n2.使用畜禽无害化智能处理设备的重点不仅仅在于杀灭畜禽中含有的有害病菌，还可将剩下的物料制成饲料废物编程珍宝，并提高经济效益。\n3.畜禽无害化智能处理设备更加的智能化，减少了人工操作，降低了使用难度，更加具有经济效益。\n4.畜禽无害化智能处理设备处理的过程可达到无二次污染，对环境有着很好的保护作用。\n5.畜禽无害化处理的应用加上政府的管辖与补助也从根本上解决了病死畜禽流入市场的问题。',
        },
        newsList4:{
          title:'动物无害化处理设备的原理',
          dateTime:'2024-5-17',
          details:'在处理动物尸体方面已有多年历史，但由于种种原因，仍有不少病死的畜禽经过不良商贩处理后流入市场，严重影响人们的健康。为了对病死畜禽进行彻底的无害化处理，现在使用化制的技术来进行处理，这样的设备我们叫做动物无害化处理设备，它的工艺原理是将病禽高温高压杀菌熟练后的脂肪和水去除，在高温的同时进行了杀菌的工作，杀菌后就已经变成了无害物料，后续可以使用多种的处理方式，比如说可以通过干燥粉碎成有机肥。这一过程可以从根本上解决病畜的无害化治疗问题。',
        },
				//产品图片
				productImg: require('../../public/image/产品1.jpg'),
				//荣誉资质，企业文化，联系我们
				honorImg: require('../../public/image/荣誉资质.jpg'),
        companyIntroduceImg:require('../../public/image/公司介绍.jpg'),
				contactUsImg: require('../../public/image/联系我们.jpg'),
				//公司图片
				companyImg: require('../../public/image/公司3.jpg'),
				//轮播图效果方法
				swiperOptions: {
					//自动切换
					autoplay: {
						delay: 6000, //时间间隔
						disableOnInteraction: false, //手动操作轮播图后不会暂停
					},
					//环路
					loop: true,
					//前进后退按钮
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					//分页器
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
					//切换效果
					effect: 'coverflow',
					// cubeEffect:{
					//   slideShadows:true,
					//   shadow:true,
					//   shadowOffset:25,
					//   shadowScale:0.9,
					// }
				},
				//轮播图数据
				swiperList: [{
          title:"畜禽无害化智能处理机",
					productName:'畜禽智能处理机',
					src: require('../../public/image/首页图片1.jpg'),
				},{
          title:"畜禽无害化智能处理机",
          productName:'畜禽智能处理机',
          src: require('../../public/image/首页图片2.jpg'),
        },{
          title:"畜禽无害化智能处理机",
          productName:'畜禽智能处理机',
          src: require('../../public/image/首页图片3.jpg'),
        }]
			}
		},
    //组件进入时触发
		mounted() {
		  this.scrollToTop();
    },
		components: {
			Swiper,
			SwiperSlide,
		},
		methods: {
		  clickQuestionIntroduce(item){
        this.$store.state.questionIntroduce=item;
        this.$router.push({path:'/PcQuestionIntroduce'}).catch(()=>{});
      },
		  //路由导向
      routing(flagString){
        if(flagString==='关于我们'){
          this.$router.push({path:'/PcAboutUs'});
        }else if(flagString==='联系我们'){
          this.$router.push({path:'/PcContactUs'});
        }else if(flagString==='公司介绍'){
          this.$router.push("/PcAboutUs");
        }else if(flagString==='荣誉资质'){
          this.$router.push("/PcHonorQualifications");
        }else if(flagString==='企业文化'){
          this.$router.push("/PcCorporateCulture");
        }else if(flagString==='产品中心'){
          this.$router.push("/PcProductCenter");
        }else if(flagString==='新闻中心'){
          this.$router.push("/PcNewsCenter");
        }else{
          this.$message({
            message:"操作失败",
            type:'error',
          })
        }
      },
      //滚动置顶
      scrollToTop(){
        const position=0;
        this.$refs.scrollContainer.scrollTop=position;
      },
			//鼠标移到新闻栏上
			div8LeftMouseOver(id){
				this.borderWidth[id]='3px';
				this.$forceUpdate();
			},
			//鼠标离开新闻栏
			div8LeftMouseLeave(id){
				this.borderWidth[id]='1px';
				this.$forceUpdate();
			},
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/computer/PcFirstPage.vue